@if (!erreurRecuperation() && donneeInit()) {
  <div id="mon-site">
    <div class="row">
      <div class="nav nav-tabs not-selectable" >
        <div class="nav-item epc-tab">
          <a class="nav-link" (click)="changerTab(1)" [ngClass]="tab() == 1 ? 'active':'' ">
            {{'GLOBAL.CARTE' | translate }}
          </a>
        </div>
        <div class="nav-item epc-tab">
          <a class="nav-link" (click)="changerTab(2)" [ngClass]="tab() == 2 ? 'active':'' ">
            {{'MON_SITE.DOCUMENTS' | translate }}
          </a>
        </div>
        @if (false) {
          <div class="nav-item epc-tab dropdown-parent"  (click)="changerTab(3)">
            <div class="nav-link" [ngClass]="tab() == 3 ? 'active':'' ">
              {{ 'Fleet Management System' }}
              <!-- <i class="fa-solid fa-caret-down"></i> -->
            </div>
            <!-- <div class="dropdown" [ngClass]="{'dropdown-show':isOpen()}">
            <div class="menu-items">
              <div class="item" (click)="changerTab(3)" > <span>Dashboard</span></div>
              <div class="item"  (mouseenter)="submenuShow()" ><span class="item">Equipments <i class="fa-solid fa-caret-right"></i></span>  </div>
            </div>
          </div>
          <div class="submenu" (mouseleave)="submenuClose()"  [ngClass]="{'submenu-show':isOpenSub()}">
            <div *ngFor="let equipment of tabEquipments" class="item" ><span>{{equipment.make + ' ' + equipment.model + ' (' + equipment.serialNumber + ')' }} </span></div>
          </div>  -->
        </div>
      }
      @if (canShowDashboard()) {
        <div class="nav-item epc-tab">
          <a class="nav-link" (click)="changerTab(4)" [ngClass]="tab() == 4 ? 'active':'' ">
            {{'MON_SITE.DASHBOARD' | translate }}
          </a>
        </div>
      }
    </div>
  </div>
  <div id="cart-container" [hidden]="tab() != 1">
    <app-carte [site]="monSite" [blastIdToZoom]="blastIdToZoom()" [hidden]="tab() != 1"></app-carte>
  </div>
  @if (monSite.nom) {
    <div id="site-container" [hidden]="tab() != 2">
      <div class="row titre">
        <h2>{{monSite.nom}}</h2>
      </div>
      <div>
        {{monSite.pays?.nom}}
      </div>
      <div id="explorer-container">
        <app-file-explorer [apiEndPoint]="'Sites'" [id]="monSite.siteId" [racine]="dossierRacine()" [hauteurExplorer]="hauteurListe()" (modifDossier)="modifDossier($event)"></app-file-explorer>
      </div>
    </div>
  }
  @if (tab() === 3 && utilService.currentSite()?.siteId === 189) {
    <div id="hiboo-container">
      <app-hiboo-dashboard style="width: 100%; position: relative;" [hidden]="tab() != 3"></app-hiboo-dashboard>
    </div>
  }
  @if (tab() === 4) {
    <div>
      <app-metabase-dashboard class="metabase-dashboard" componentSelector="app-mon-site" [dashboardUrl]="dashboardUrl()"></app-metabase-dashboard>
    </div>
  }
  @if (erreurRecuperation()) {
    <div class="custom-alert custom-alert-sm">
      {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
    </div>
  }
</div>
}
